import { clearJwtAccessTokenInBrowser } from './jwtCookieHelpers';

/** BFF сброс httpOnly refresh + явная очистка access_token в JS. */
export async function clearJwtSessionInBrowser(options) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    await fetch('/api/logout/', {
      method: 'GET',
      credentials: 'same-origin',
    });
  } catch (e) {
    /* ignore */
  }

  clearJwtAccessTokenInBrowser();

  if (options && options.redirectToSignIn) {
    window.location.href = '/auth/signin/';
  }
}
